import React, { useEffect, useState } from 'react'
import { canCancel, formatDateRange, getStatusClass } from '../../utils/data'
import { CiLocationOn } from 'react-icons/ci'
import { useTranslation } from 'react-i18next'
import { FaBed, FaCalendarAlt, FaStar } from 'react-icons/fa'
import { GrStatusUnknown } from "react-icons/gr";
import { useParams } from 'react-router-dom'
import { useDispatch, useSelector } from 'react-redux'
import { AppDispatch, RootState } from '../../store'
import { addPayment, cancelBook, fetchBookById, } from '../../features/home/bookingSlice'
import InnerLoading from '../ui/InnerLoading'
import { IoPricetagsOutline } from "react-icons/io5";
import LocationButton from '../ui/LocationButton'
import { MdOutlineNumbers, MdOutlinePayments, MdAddShoppingCart } from 'react-icons/md'
import { HiHashtag } from "react-icons/hi2";

import { Booking } from '../../types'
import ConfirmDeleteModal from '../dashboard/models/ConfirmDeleteModal'
import { LiaStarOfLifeSolid } from "react-icons/lia";
import RatingModal from '../ui/RatingModal'
import ChangePaymentMethod from './ChangePaymentMethod'
import toast from 'react-hot-toast'
import { fetchPlaceReviews } from '../../features/admin/placeSlice'
const BookDetails = () => {
    const { bookId } = useParams();
    const { t, i18n } = useTranslation()
    const dispatch = useDispatch<AppDispatch>()
    const [deleteModalOpen, setDeleteModalOpen] = useState(false);
    const [showReviewPage, setShowReviewPage] = useState(false);
    const [openChange, setOpenChange] = useState(false);
    const [selectedBook, setSelectedBook] = useState<Booking | null>();
    const { booking, loading } = useSelector((state: RootState) => state.bookingSlice)
    const { reviews } = useSelector((state: RootState) => state.placeSlice)
    const { user } = useSelector((state: RootState) => state.user)
    const isHotel = booking?.place?.subCategory.id === 1;
    useEffect(() => {
        dispatch(fetchBookById(Number(bookId)))
        booking?.place.id && dispatch(fetchPlaceReviews(booking?.place.id));
    }, [dispatch, bookId, booking?.place.id])

    const handleDelete = async () => {
        if (selectedBook !== null) {
            dispatch(cancelBook({ userId: selectedBook?.userId, bookId: selectedBook?.id }));
            dispatch(fetchBookById(Number(bookId)))
            setSelectedBook(null);
        }
    };

    const confirmDelete = (book: Booking) => {
        setSelectedBook(book);
        setDeleteModalOpen(true);
    };

    const handleConfirmPayment = async () => {
        if (booking?.paymentMethod === "Online") {
            try {
                const res = await dispatch(addPayment({ userId: user?.id, bookId: booking?.id,type:"Stay"})).unwrap();

                if (res?.data.url) {
                    window.location.href = res.data.url;
                }
            } catch (err) {
                console.error('Online payment error:', err);
            }

        } else {
            toast.error('Wallet payment coming soon...');
        }
    }
    if (loading) return <InnerLoading />
    return (
        <div>
            <div className="flex-between">
                <h3 className='text-2xl font-semibold mb-4'>{t("book-details")}</h3>
                <button onClick={() => setShowReviewPage(true)} className=" flex-center gap-2 xs:text-base md:text-lg bg-primary rounded-lg py-2 px-4 text-white">
                    <p>{t("feedback")}</p>
                    <LiaStarOfLifeSolid />
                </button>
            </div>


            <div className=' grid sm:grid-cols-2 xs:grid-cols-1 gap-5'>
                <div>
                    <h3 className='text-xl font-semibold mb-4'>{t("your-stay")}</h3>
                    <div className="flex w-full overflow-hidden rounded-2xl border shadow-sm bg-white" >
                        <div className="relative xs:w-32 sm:w-40 overflow-hidden">
                            <img
                                src={booking?.place?.images?.[0]?.url || "/asset/modern-commercial-building.webp"}
                                alt={booking?.place?.title}
                                className="w-full h-full object-cover"
                            />
                            <span
                                className={`absolute top-3 ${i18n.language === 'ar' ? 'right-3' : 'left-3'
                                    } rounded-md bg-primary px-3 py-1 text-xs sm:text-sm text-white`}
                            >
                                {booking?.place?.subCategory?.title || booking?.place?.type}
                            </span>
                        </div>
                        <div className="flex flex-col justify-between flex-1 p-3">
                            <div className="flex items-center justify-between">
                                <div className="flex items-center gap-2 text-sm text-gray-600">
                                    <FaStar className="text-secondry" />
                                    {booking?.place?.rate?.toFixed(1)}{' '}
                                    <span className="text-gray-400">
                                        ({reviews?.length} {t('reviews')})
                                    </span>
                                </div>
                                <span
                                    className={`xs:text-xs sm:text-sm font-medium ${getStatusClass(
                                        booking?.state
                                    )}`}
                                >
                                    {booking?.state === "Pending" && booking.paymentMethod === "Cash" ? t("pending-cash") : t(`${booking?.state.toLowerCase()}`) || booking?.state}
                                </span>
                            </div>
                            <h2 className="mt-1 text-lg font-bold">
                                {booking?.place?.title}
                            </h2>
                            <p className="flex items-center gap-1 text-sm text-gray-500">
                                <CiLocationOn /> {booking?.place?.location}
                            </p>
                        </div>
                    </div>
                    <section className="mt-10  w-full">
                        <h2 className="text-2xl font-semibold mb-4">{t("amenities")} </h2>
                        <div className="grid grid-cols-2 gap-4">

                            {booking?.place?.amenities.length === 0 && <div className=" text-textSecond">{t("no-services")}</div>}
                            {booking?.place?.amenities.map((amenity: any) => (
                                <div key={amenity.id} className="flex items-center gap-3  rounded-lg">
                                    <img src={amenity.image} alt={amenity.title} className="w-6 h-6" />
                                    <span className="text-sm text-nowrap text-gray-800">{amenity.title}</span>
                                </div>
                            ))}
                        </div>
                    </section>
                </div>
                <div>
                    <h3 className='text-xl font-semibold mb-4'>{t("your-booking")}</h3>
                    <div className=' flex flex-col justify-between h-full'>
                        <div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <HiHashtag />
                                    <span>{t("bookingId")}</span>
                                </p>
                                {booking?.id}
                            </div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <FaCalendarAlt />
                                    <span>{t('dates')}</span>
                                </p>
                                {booking?.checkIn && <p>{booking.place.type === "Hall" ? formatDateRange(booking?.checkIn, booking?.checkOut, true) : formatDateRange(booking?.checkIn, booking?.checkOut)}</p>}
                            </div>
                            {isHotel && (
                                <>
                                    <div className="flex justify-between pt-2 text-sm text-textSecond">
										<div className="flex flex-1 items-center gap-1 text-darkColor font-medium">
											<FaBed />
											<p>{t('room-type')}</p>
										</div>
										<p >
											{booking.rooms.map(room => room.type).join("، ")}
										</p>
									</div>
									<div className="flex justify-between pt-2 text-sm text-textSecond">
										<div className="flex items-center gap-1 text-darkColor font-medium">
											<MdOutlineNumbers />
											<p>{t('room-number')}</p>
										</div>
										{booking.rooms.map(room => room.roomNumber).join("، ")}
									</div>
                                </>
                            )}
                           

                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <IoPricetagsOutline />
                                    <span>{t('price')}</span>
                                </p>
                                <p className={` font-medium`}  >
                                    {booking?.price.toFixed(2)} {booking?.place.currencyCode}
                                </p>
                            </div>
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <MdOutlinePayments />
                                    <span>{t('paymentMethod')}</span>
                                </p>
                                <p className={` font-medium`}  >
                                    {t(`${booking?.paymentMethod}`)}
                                </p>
                            </div>
                            {booking?.optionalServices&& 
                            <div className="flex justify-between  pt-2 text-sm text-textSecond">
                                <p className="flex  gap-1 text-darkColor font-medium">
                                    <MdAddShoppingCart className="text-base text-primaryColor" />
                                    <span>{t("additional-service")}</span>
                                </p>

                                <div className="flex flex-wrap items-center gap-2 flex-col">
                                    {booking?.optionalServices.map((item, index) => (
                                        <div
                                            key={index}
                                            className=" font-medium"
                                        >
                                            <span>{item.title}</span>
                                        </div>
                                    ))}
                                </div>
                            </div>}
                            <div className="flex-between pt-2 text-sm text-textSecond">
                                <p className="flex items-center gap-1 text-darkColor font-medium">
                                    <GrStatusUnknown />
                                    <span>{t('Status')}</span>
                                </p>
                                <p className={` font-medium ${getStatusClass(booking?.state)}`}  >
                                    {booking?.state === "Pending" && booking.paymentMethod === "Cash" ? t("pending-cash") : t(`${booking?.state.toLowerCase()}`) || booking?.state}
                                </p>
                            </div>
                            {booking?.state === 'Pending' && (
                                <div className="pt-2 w-full">
                                    <button
                                        onClick={() => setOpenChange(true)}
                                        className=" text-sm text-secondry underline" >
                                        {t('change-payment-Method')}
                                    </button>
                                </div>
                            )}
                            <div className=' flex justify-between w-full gap-3'>
                                {canCancel(String(booking?.checkIn)) && booking?.state !== 'Cancelled' && booking?.state !== 'CancelledByHotel' && booking?.state !== 'Returned' && (
                                    <div className="w-full pt-2">
                                        <button
                                            className="w-full text-sm bg-red-600 focus:outline-none text-white rounded-lg py-2"
                                            onClick={() => booking && confirmDelete(booking)}
                                        >
                                            {t('cancel-booking')}
                                        </button>
                                    </div>
                                )}
                                {booking?.state === 'Pending' && booking?.paymentMethod !== 'Cash' && (
                                    <div className="pt-2 w-full">
                                        <button
                                            onClick={handleConfirmPayment}
                                            className="w-full text-sm bg-primary focus:outline-none text-white rounded-lg py-2" >
                                            {t('confirmPayment')}
                                        </button>
                                    </div>
                                )}

                            </div>
                        </div>
                        <LocationButton link={`/place/${booking?.place?.id}/map-view`} />
                        <ConfirmDeleteModal
                            isOpen={deleteModalOpen}
                            onClose={() => setDeleteModalOpen(false)}
                            onConfirm={handleDelete}
                            messageKey="cancel-book-confirm"
                        />
                        {showReviewPage &&
                            <div>
                                <RatingModal isOpen={showReviewPage} onClose={() => setShowReviewPage(false)} type={'Place'} bookingPlace={booking} />
                            </div>
                        }
                        {openChange && booking &&
                            <div>
                                <ChangePaymentMethod isOpen={openChange}
                                    onClose={() => {
                                        setOpenChange(false)
                                        dispatch(fetchBookById(Number(bookId)))
                                    }
                                    }
                                    current={booking?.paymentMethod} bookId={booking.id} type='place' paymentAvailabel={booking.place.paymentMethod} />
                            </div>
                        }
                    </div>
                </div>
            </div>
        </div>
    )
}

export default BookDetails
